export const CONFIRM_LEAVE_PAGE = 'Pagina verlaten.\n\nZeker weten? Dit lijstje is nog niet opgeslagen.\n\nOK = Verlaten\nCancel = Op pagina blijven';